// icons
export { default as VuetifyIcons } from './icons.js'

// components
export { default as CookieConsent } from './components/CookieConsent.vue'
export { default as VideoPlayer } from './components/VideoPlayer.vue'
export { default as Gallery } from './components/Gallery.vue'
export { default as IconFontawesome } from './components/IconFontawesome.vue'
export { default as IconCalendar } from './components/IconCalendar.vue'
export { default as AlertUnsupportedBrowser } from './components/AlertUnsupportedBrowser.vue'
export { default as SplitButton } from './components/SplitButton.vue'
export { default as ListOptions } from './components/ListOptions.vue'
export { default as ButtonTooltip } from './components/ButtonTooltip.vue'
export { default as TabsBase } from './components/TabsBase.vue'
export { default as LongText } from './components/LongText.vue'
export { default as JsonDetails } from './components/JsonDetails.vue'
export { default as InputSelectAudioInput } from './components/InputSelectAudioInput.vue'
export { default as InputSelectVideoInput } from './components/InputSelectVideoInput.vue'
export { default as AdministrationOverviewItem } from './components/AdministrationOverviewItem.vue'
export { default as AdministrationSettingsCategory } from './components/AdministrationSettingsCategory.vue'
export { default as AdministrationSettingsSwitch } from './components/AdministrationSettingsSwitch.vue'

// utils
export { default as AlertUtils } from './utils/alert.js'
export { default as ArrayUtils } from './utils/array.js'

function installI18n(instance) {
  if (instance) {
    // eslint-disable-next-line no-case-declarations
    const locales = require.context(
      './locale',
      true,
      /[A-Za-z0-9-_,\s]+\.json$/i
    )
    locales.keys().forEach((key) => {
      const matched = key.match(/([A-Za-z0-9-_]+)\./i)
      if (matched && matched.length > 1) {
        const locale = matched[1]
        const origMessages = instance.getLocaleMessage(locale)

        // we will merge the locale messages with our default messages. After that we will merge the messages from the user back, so they will override our default messages.
        instance.mergeLocaleMessage(locale, locales(key))
        instance.mergeLocaleMessage(locale, origMessages)
      }
    })
  }
}

export default {
  install(Vue, options) {
    const o = options || {}
    const i18n = o.i18n || null
    const vuetify = o.vuetify || {}
    const apollo = o.apollo || {}

    installI18n(i18n)

    this.$vuetify = vuetify
    this.$apollo = apollo
  }
}
